import {remCalc} from '../../_utils'

/**
 * the breadcrumb style
 */
export default {
    baseStyle: {
        container: {
            textStyle: 'body-xsmall',
            spacing: 0,
            paddingBottom: {base: remCalc(8), md: remCalc(16)},
            paddingTop: {base: remCalc(8), md: remCalc(16)},
            maxWidth: '100%',
        },
        icon: {
            color: 'border.light',
        },
        link: {
            textStyle: 'body-xsmall',
            textDecoration: 'none',
            color: 'text.secondary',
            _hover: {
                textDecoration: 'underline',
            },
        },
        lastLink: {
            textStyle: 'body-xsmall',
            cursor: 'none',
            color: 'text.default',
            pointerEvents: 'none',
            _hover: {
                textDecoration: 'none',
            },
        },
        item: {
            textStyle: 'body-xsmall',
            color: 'text.secondary',
            textDecoration: 'none',
        },
    },
    parts: ['container', 'icon', 'link', 'item', 'lastLink'],
}
